import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {useTable} from 'react-table';
import * as actions from '../_redux/usersClientActionsActions';
import * as commonColumnFormatters from '../../_common/column-formatters';
import * as columnFormatters from './column-formatters';
import {useUsersClientActionsContext} from '../context/UsersClientActionsContext';
import useInfiniteScrollControl from '../../_common/components/_custom-hooks/useInfiniteScrollControl';
import CommonGrid from "../../_common/components/CommonGrid/CommonGrid";

export function UsersClientActionsTable() {
  const prefix = 'users-client-actions-column';
  const {formatMessage} = useIntl();
  const [tableRows, setTableRows] = useState([]);
  const columns = useMemo(() => [
    {
      accessor: 'username',
      Header: formatMessage({id: `${prefix}-username`, defaultMessage: 'User name'})
    },
    {
      accessor: 'createdAt',
      Header: formatMessage({id: `${prefix}-createdAt`, defaultMessage: 'Created at'})
    },
    {
      accessor: 'action',
      Header: formatMessage({id: `${prefix}-action`, defaultMessage: 'Action'})
    },
    {
      accessor: 'relevantData',
      Header: formatMessage({id: `${prefix}-relevantData`, defaultMessage: 'Relevant data'})
    },
    {
      accessor: 'result',
      Header: formatMessage({id: `${prefix}-result`, defaultMessage: 'Result'})
    },
  ], [formatMessage]);
  const data = useMemo(() => [
    ...tableRows.map((item) => {
      return {
        username: commonColumnFormatters.SeveralItemsColumnFormatter([item.username, item.userEmail].filter(Boolean)),
        createdAt: commonColumnFormatters.DateColumnFormatter(item.createdAt, true),
        action: commonColumnFormatters.BoldColumnFormatter(item.action),
        relevantData: columnFormatters.ActionDataColumnFormatter(item),
        result: columnFormatters.ResultColumnFormatter(item.result),
      };
    })
  ], [tableRows]);

  const infiniteScrollProps = useInfiniteScrollControl({
    currentStateStoreId: 'usersClientActions',
    UIContext: useUsersClientActionsContext(),
    getNewEntities: actions.getUsersClientActions,
    getNextEntities: actions.getNextUsersClientActions,
    onEntitiesChange: entities => setTableRows(entities),
    dataLength: tableRows.length,
    scrollableTarget: 'scrollContainer',
    scrollThreshold: 0.9,
    loader: (
      <div className={'spinner-container'}>
        <span className={'spinner spinner-md spinner-primary'}/>
      </div>
    ),
    style: {
      overflow: 'inherit'
    },
  });

  return (
    <CommonGrid
      infiniteScrollProps={infiniteScrollProps}
      tableProps={useTable({columns, data})}
      customTableStyles={'users-client-actions-table'}
    />
  );
}
